export type { FC } from "react";

export interface Props {
  showTabBar: (v: boolean) => void;
}

export enum ETabs {
  ENC_KEY,
  FA,
  TRUST,
}
